import React, { useContext, useEffect, useState } from 'react';
import { TimeRangeContext } from "../../../context/TimeRangeContext";
import { buildApiQuery } from "../../../helpers/timeRangeUtils";
import Skeleton from 'react-loading-skeleton';

// Helper.
import Helper from "../../../helpers/Helper";

import HostApi from "../../../api/host/HostApi";

function AverageStatistic(props: { hostId: number, statistic: string, metric: number | null }) {
    const [previousMetric, setPreviousMetric] = useState<number | null>(null);
    const [differenceMetric, setDifferenceMetric] = useState<number | null>(null);
    const timeRangeContext = useContext(TimeRangeContext)

    useEffect(() => {

        const getStatistic = async() => {
            let previousAverageMetric: number = 0;

            const previousData = await HostApi.getHostStatisticSummary(buildApiQuery(timeRangeContext.timeRange, true), props.statistic, props.hostId);
            if (previousData.length > 0) {
                previousAverageMetric = Math.round(previousData[0].avg);
            }

            let difference = Math.round(((((props.metric !== null) ? props.metric : 0) - previousAverageMetric) / previousAverageMetric) * 100);

            if (isNaN(difference)) {
                difference = 0;
            }

            if (difference === Infinity || difference === -Infinity) {
                difference = 100;
            }

            setPreviousMetric(previousAverageMetric);
            setDifferenceMetric(difference);
        }

        const comparisonSupported = Helper.isComparisonSupported(timeRangeContext)
        if (comparisonSupported) {
            getStatistic();
        }

    }, [timeRangeContext, props.hostId, props.statistic, props.metric]);

    return (
        props.metric === null ? (
            <Skeleton/>
        ) : (
            <React.Fragment>
                <span className="table-metric-value">
                    {Math.round(props.metric)}%
                </span>
                {previousMetric !== null && (
                    <span className="comparison">
                            {previousMetric}%
                        {differenceMetric !== null && (
                            <span>({differenceMetric}%)</span>
                        )}
                        {props.metric === previousMetric ? (
                            <i className="fal fa-equals fa-fw equals"/>
                        ) : (
                            props.metric > previousMetric ? (
                                <i className="fal fa-long-arrow-up fa-fw increase"/>
                            ) : (
                                <i className="fal fa-long-arrow-up fa-fw decrease"/>
                            )
                        )}
                        </span>
                )}
            </React.Fragment>
        )
    );
}

export default AverageStatistic;